var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import Icon from "../Icon";
var Svg = styled(Icon)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
export var ArrowTop = function (_a) {
    var _b = _a.color, color = _b === void 0 ? "#E2665C" : _b, _c = _a.width, width = _c === void 0 ? 24 : _c, _d = _a.height, height = _d === void 0 ? 24 : _d, className = _a.className;
    return (React.createElement("div", { style: { width: width, height: height }, className: className },
        React.createElement(Svg, { viewBox: "0 0 24 24" },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.9011 9.10053L10.9011 18.5858L12.9011 18.5858L12.9011 8.89949L16.2442 12.2426L17.6585 10.8284L12 5.16993L10.5857 6.58414L10.5874 6.5858L6.34476 10.8284L7.75897 12.2427L10.9011 9.10053Z", fill: color }))));
};
var templateObject_1;
